export default {
  login: '/login',
  adminManagement: '/adminManagement',
  userManagement: '/userManagement',
  adManagement: '/adManagement',
  settings: '/settings',
  userDetails: '/userManagement/details/:name/:id',
};
